/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update settlement destination request
 */
export interface UpdateSettlementDestinationRequest {
  /**
   * Withdraw info ID.
   */
  settlementDestinationId: number;
  /**
   * New client tag.
   */
  clientTag?: string;
  /**
   * New admin tag.
   */
  adminTag?: string;
  /**
   * Inclusive lower bound of the automated withdrawal range, in asset units. For Fireblocks destinations set minAmount and maxAmount without bankApiParams. Leave minAmount and maxAmount empty to switch automation off.
   */
  minAmount?: number;
  /**
   * Inclusive upper bound of the automated withdrawal range, in asset units.
   */
  maxAmount?: number;
  /**
   * Bank API request params as a JSON object. Not used for Fireblocks destinations.
   */
  bankApiParams?: string;
}
